module.exports = __webpack_public_path__ + "img/hz-jd.67b21b4a.png";